(function() {
    'use strict';

    angular.module('blocks.authentication', [
        'blocks.logger',
        'permission',
        'permission.ui',
        'angular-jwt',
        'app.service']);
})();
